/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_2_DInputs */

const en_mk_tut_gl_2_d = /** @type {(inputs: Mk_Tut_Gl_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A working group such as Marketing or Finance. Each one has its own channel and agent.`)
};

const id_mk_tut_gl_2_d = /** @type {(inputs: Mk_Tut_Gl_2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelompok kerja seperti Marketing atau Finance. Tiap divisi punya channel dan agennya sendiri.`)
};

/**
* | output |
* | --- |
* | "A working group such as Marketing or Finance. Each one has its own channel and agent." |
*
* @param {Mk_Tut_Gl_2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_2_d = /** @type {((inputs?: Mk_Tut_Gl_2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_2_d(inputs)
	return en_mk_tut_gl_2_d(inputs)
});